// import React from "react";
import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import LoginComponent from '../components/login-registration/loginComponent';

function ARPanel() {

    return (
        <div >
            <Row className="align-items-center justify-content-center">

                {/* Text Content Column */}
                <Col md={6} className="text-center text-md-start mb-4 mb-md-0">

                    {/* NEW Placement: Above the headline */}
                    <span className="ar-new-badge ar-new-tagline d-inline-block mb-3">NEW FEATURE</span>

                    <h2 className="ar-hero-headline mb-3">
                        Immerse Yourself: Biology Beyond the Screen.
                    </h2>
                    <p className="ar-hero-text  mb-4">
                        Step into an unparalleled learning experience. Our cutting-edge Augmented Reality transforms abstract biological concepts into almost tangible, interactive 3D models you can explore in your own space. Truly see, feel, and understand life's intricacies.
                    </p>
                    <a href="/ar-features-page" className="ar-hero-button-link">
                        <button className="ar-hero-button">
                            Discover the AR Experience
                        </button>
                    </a>
                </Col>

                {/* Image Column */}
                <Col md={6} className="d-flex justify-content-center">
                    <div className="ar-hero-image-wrapper">
                        <img
                            src="https://storage.googleapis.com/sb-general/ARImages/Screenshot_20250728-180611.png" /* REPLACE with your best AR app screenshot */
                            alt="Augmented Reality app in action"
                            className="img-fluid rounded-lg ar-hero-image"
                        />
                    </div>
                </Col>
            </Row>
        </div>
    );



    //   const [userName, setUserName] = useState({});
    //   const [userId, setUserId] = useState({});

    //   useEffect(() => {
    //     setUserDetails();
    //   }, []);

    //   const setUserDetails = async () => {
    //     setUserName('john');
    //     setUserId('1234');
    //   }

    //   return (
    //     <div >
    //       <Container>
    //         <Row>
    //           <Col md={{ span: 6, offset: 3 }}>
    //             <LoginComponent />

    //           </Col>
    //         </Row>
    //       </Container>
    //     </div>
    //   );
}

export default ARPanel;